var _toConsumableArray = require("/pubskape-frontend/node_modules/@babel/runtime/helpers/toConsumableArray");

/**
 * Tagify (v 4.9.8) - tags input component
 * By Yair Even-Or
 * Don't sell this code. (c)
 * https://github.com/yairEO/tagify
 */
!function (e, n) {
  "function" == typeof define && define.amd ? define([], n) : "object" == typeof exports ? module.exports = n() : e.React.tagify = n();
}(this, function () {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: !0
  }), exports.default = exports.MixedTags = void 0;

  var e,
      n = function (e, n) {
    if (!n && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
      default: e
    };
    var t = a(n);
    if (t && t.has(e)) return t.get(e);
    var o = {},
        r = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var u in e) {
      if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var c = r ? Object.getOwnPropertyDescriptor(e, u) : null;
        c && (c.get || c.set) ? Object.defineProperty(o, u, c) : o[u] = e[u];
      }
    }

    o.default = e, t && t.set(e, o);
    return o;
  }(require("react")),
      t = require("react-dom/server"),
      o = require("prop-types"),
      r = (e = require("./tagify.js")) && e.__esModule ? e : {
    default: e
  };

  var u = ["children"];

  function a(e) {
    if ("function" != typeof WeakMap) return null;
    var n = new WeakMap(),
        t = new WeakMap();
    return (a = function a(e) {
      return e ? t : n;
    })(e);
  }

  function c() {
    return (c = Object.assign || function (e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = arguments[n];

        for (var o in t) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function d(e, n) {
    if (null == e) return {};

    var t,
        o,
        r = function (e, n) {
      if (null == e) return {};
      var t,
          o,
          r = {},
          u = Object.keys(e);

      for (o = 0; o < u.length; o++) {
        t = u[o], n.indexOf(t) >= 0 || (r[t] = e[t]);
      }

      return r;
    }(e, n);

    if (Object.getOwnPropertySymbols) {
      var u = Object.getOwnPropertySymbols(e);

      for (o = 0; o < u.length; o++) {
        t = u[o], n.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (r[t] = e[t]);
      }
    }

    return r;
  }

  var i = function i(e) {
    return e;
  };

  var l = function l(_ref) {
    var e = _ref.name,
        o = _ref.value,
        _ref$loading = _ref.loading,
        u = _ref$loading === void 0 ? !1 : _ref$loading,
        _ref$onInput = _ref.onInput,
        a = _ref$onInput === void 0 ? i : _ref$onInput,
        _ref$onAdd = _ref.onAdd,
        c = _ref$onAdd === void 0 ? i : _ref$onAdd,
        _ref$onRemove = _ref.onRemove,
        d = _ref$onRemove === void 0 ? i : _ref$onRemove,
        _ref$onEditInput = _ref.onEditInput,
        l = _ref$onEditInput === void 0 ? i : _ref$onEditInput,
        _ref$onEditBeforeUpda = _ref.onEditBeforeUpdate,
        s = _ref$onEditBeforeUpda === void 0 ? i : _ref$onEditBeforeUpda,
        _ref$onEditUpdated = _ref.onEditUpdated,
        f = _ref$onEditUpdated === void 0 ? i : _ref$onEditUpdated,
        _ref$onEditStart = _ref.onEditStart,
        p = _ref$onEditStart === void 0 ? i : _ref$onEditStart,
        _ref$onEditKeydown = _ref.onEditKeydown,
        y = _ref$onEditKeydown === void 0 ? i : _ref$onEditKeydown,
        _ref$onInvalid = _ref.onInvalid,
        g = _ref$onInvalid === void 0 ? i : _ref$onInvalid,
        _ref$onClick = _ref.onClick,
        w = _ref$onClick === void 0 ? i : _ref$onClick,
        _ref$onKeydown = _ref.onKeydown,
        h = _ref$onKeydown === void 0 ? i : _ref$onKeydown,
        _ref$onFocus = _ref.onFocus,
        O = _ref$onFocus === void 0 ? i : _ref$onFocus,
        _ref$onBlur = _ref.onBlur,
        b = _ref$onBlur === void 0 ? i : _ref$onBlur,
        _ref$onChange = _ref.onChange,
        m = _ref$onChange === void 0 ? i : _ref$onChange,
        _ref$onDropdownShow = _ref.onDropdownShow,
        v = _ref$onDropdownShow === void 0 ? i : _ref$onDropdownShow,
        _ref$onDropdownHide = _ref.onDropdownHide,
        E = _ref$onDropdownHide === void 0 ? i : _ref$onDropdownHide,
        _ref$onDropdownSelect = _ref.onDropdownSelect,
        j = _ref$onDropdownSelect === void 0 ? i : _ref$onDropdownSelect,
        _ref$onDropdownScroll = _ref.onDropdownScroll,
        D = _ref$onDropdownScroll === void 0 ? i : _ref$onDropdownScroll,
        _ref$onDropdownNoMatc = _ref.onDropdownNoMatch,
        M = _ref$onDropdownNoMatc === void 0 ? i : _ref$onDropdownNoMatc,
        _ref$onDropdownUpdate = _ref.onDropdownUpdated,
        x = _ref$onDropdownUpdate === void 0 ? i : _ref$onDropdownUpdate,
        S = _ref.readOnly,
        k = _ref.disabled,
        I = _ref.children,
        _ref$settings = _ref.settings,
        R = _ref$settings === void 0 ? {} : _ref$settings,
        _ref$InputMode = _ref.InputMode,
        N = _ref$InputMode === void 0 ? "input" : _ref$InputMode,
        P = _ref.autoFocus,
        T = _ref.className,
        C = _ref.whitelist,
        U = _ref.tagifyRef,
        _ref$placeholder = _ref.placeholder,
        F = _ref$placeholder === void 0 ? "" : _ref$placeholder,
        _ = _ref.defaultValue,
        V = _ref.showDropdown;
    var q = (0, n.useRef)(),
        B = (0, n.useRef)(),
        K = (0, n.useRef)(),
        W = _ || o,
        A = (0, n.useMemo)(function () {
      return {
        ref: B,
        name: e,
        defaultValue: I || "string" == typeof W ? W : JSON.stringify(W),
        className: T,
        readOnly: S,
        disabled: k,
        autoFocus: P,
        placeholder: F
      };
    }, []),
        H = (0, n.useCallback)(function () {
      P && K.current && K.current.DOM.input.focus();
    }, [K]);
    return (0, n.useEffect)(function () {
      !function (e) {
        if (e) {
          var _loop = function _loop(_o) {
            var r = e[_o];
            String(r).includes("jsxRuntime") && (e[_o] = function () {
              for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
                e[_key] = arguments[_key];
              }

              return (0, t.renderToStaticMarkup)(n.default.createElement(r, {
                props: e
              }));
            });
          };

          for (var _o in e) {
            _loop(_o);
          }
        }
      }(R.templates), "textarea" == N && (R.mode = "mix"), C && C.length && (R.whitelist = C);
      var e = new r.default(B.current, R);
      return e.on("input", a).on("add", c).on("remove", d).on("invalid", g).on("keydown", h).on("focus", O).on("blur", b).on("click", w).on("change", m).on("edit:input", l).on("edit:beforeUpdate", s).on("edit:updated", f).on("edit:start", p).on("edit:keydown", y).on("dropdown:show", v).on("dropdown:hide", E).on("dropdown:select", j).on("dropdown:scroll", D).on("dropdown:noMatch", M).on("dropdown:updated", x), U && (U.current = e), K.current = e, H(), function () {
        e.destroy();
      };
    }, []), (0, n.useEffect)(function () {
      H();
    }, [P]), (0, n.useEffect)(function () {
      var _K$current$settings$w;

      q.current && (K.current.settings.whitelist.length = 0, C && C.length && (_K$current$settings$w = K.current.settings.whitelist).push.apply(_K$current$settings$w, _toConsumableArray(C)));
    }, [C]), (0, n.useEffect)(function () {
      var e = K.current.getInputValue();
      q.current && !function (e, n) {
        var t = function t(e) {
          return "string" == typeof e ? e : JSON.stringify(e);
        };

        return t(e) == t(n);
      }(o, e) && K.current.loadOriginalValues(o);
    }, [o]), (0, n.useEffect)(function () {
      q.current && K.current.toggleClass(T);
    }, [T]), (0, n.useEffect)(function () {
      q.current && K.current.loading(u);
    }, [u]), (0, n.useEffect)(function () {
      q.current && K.current.setReadonly(S);
    }, [S]), (0, n.useEffect)(function () {
      q.current && K.current.setDisabled(k);
    }, [k]), (0, n.useEffect)(function () {
      var e = K.current;
      q.current && (V ? (e.dropdown.show.call(e, V), e.toggleFocusClass(!0)) : e.dropdown.hide.call(e));
    }, [V]), (0, n.useEffect)(function () {
      q.current = !0;
    }, []), n.default.createElement("div", {
      className: "tags-input"
    }, n.default.createElement(N, A));
  };

  l.propTypes = {
    name: o.string,
    value: (0, o.oneOfType)([o.string, o.array]),
    loading: o.bool,
    children: (0, o.oneOfType)([o.string, o.array]),
    onChange: o.func,
    readOnly: o.bool,
    settings: o.object,
    InputMode: o.string,
    autoFocus: o.bool,
    className: o.string,
    tagifyRef: o.object,
    whitelist: o.array,
    placeholder: o.string,
    defaultValue: (0, o.oneOfType)([o.string, o.array]),
    showDropdown: (0, o.oneOfType)([o.string, o.bool]),
    onInput: o.func,
    onAdd: o.func,
    onRemove: o.func,
    onEditInput: o.func,
    onEditBeforeUpdate: o.func,
    onEditUpdated: o.func,
    onEditStart: o.func,
    onEditKeydown: o.func,
    onInvalid: o.func,
    onClick: o.func,
    onKeydown: o.func,
    onFocus: o.func,
    onBlur: o.func,
    onDropdownShow: o.func,
    onDropdownHide: o.func,
    onDropdownSelect: o.func,
    onDropdownScroll: o.func,
    onDropdownNoMatch: o.func,
    onDropdownUpdated: o.func
  };
  var s = n.default.memo(l);
  s.displayName = "Tags";

  exports.MixedTags = function (e) {
    var t = e.children,
        o = d(e, u);
    return n.default.createElement(s, c({
      InputMode: "textarea"
    }, o), t);
  };

  var f = s;
  return exports.default = f, exports;
});